import routes from 'app/team-account/routes';

export default {
  routes,
};
